// removed by extract-text-webpack-plugin
module.exports = {"SongList":"src-components-EightRooms-SongList----SongList-module---SongList---28G-J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EightRooms/SongList/SongList.module.css
// module id = 130
// module chunks = 86121489336791 258137473035900